import { keyframes } from "styled-components";

export const pulse = keyframes`
    50% { transform: scale(.9,.9) };
`;
